// generated

import { Container } from "@material-ui/core";

import React from "react";
import { useAppContext } from "@qpr/client-api-base/context/AppCtxProvider";
import useLink from "@qpr/client-api-base/hooks/useLink";
import useHierarchy from "backend/hooks/elements/useHierarchy";
import Loader from "@qpr/client-api-base/ui/components/Loader";
import useElement from "backend/hooks/elements/useElement";
import SplitView from "design/layouts/SplitView";
import PageContainer from "design/layouts/PageContainer";
import StrategyToolbar from "components/toolbars/StrategyToolbar";
import Page from "design/pages/Page";
import { PerformanceSummaryBars } from "design/components/lists/SummaryCard";
import OverallPerformanceCard from "design/components/cards/OverallPerformanceCard";
import { ElementOverviewDonutCard } from "design/components/cards/ElementOverviewDonutCard";
import useScorecardTopElement from "backend/hooks/model/useScorecardTopElement";
import { IChartSelectEvent } from "design/components/charts/types";
import KPIDrillDown from "design/components/popups/KPIDrillDown";
import flattenHierarchy from "backend/flattenHierarchy";
import InitiativeDrillDown from "design/components/popups/InitiativeDrillDown";
import Todo from "design/components/misc/Todo";

const Overview = (props: {
  elementId?: string;
  setId?: string;
  backgroundColor?: string;
  isComponent?: boolean;
  hideRanges?: boolean;
}) => {
  const { data: root } = useScorecardTopElement("L0");

  const ctx = useAppContext();
  const link = useLink();

  const [showKPIModal, setShowKPIModal] =
    React.useState<IChartSelectEvent | null>(null);
  const [showInitiatives, setShowInitiatives] =
    React.useState<IChartSelectEvent | null>(null);

  const {
    data,
    isLoading: isDataLoading,
    isError,
    isPreviousData,
    isRefetching,
  } = useHierarchy(ctx.elementId || root?.id);

  const overviewKPIlist = React.useMemo(() => {
    return flattenHierarchy(data).filter((el) => el.typename === "KPI");
  }, [data]);

  const overviewInitiativelist = React.useMemo(() => {
    return flattenHierarchy(data).filter((el) => el.typename === "Initiative");
  }, [data]);

  const { data: el, isLoading: isElementLoading } = useElement(
    ctx.elementId || root?.id
  );

  if (
    !data ||
    isElementLoading ||
    isDataLoading ||
    isRefetching ||
    isPreviousData
  )
    return (
      <div>
        <StrategyToolbar />
        <Loader />
      </div>
    );

  return (
    <Page
      isLoading={
        !data ||
        isElementLoading ||
        isDataLoading ||
        isRefetching ||
        isPreviousData
      }
      Toolbar={StrategyToolbar}
    >
      <PageContainer>
        <KPIDrillDown
          title={
            showKPIModal?.name === "No Value"
              ? "KPIs with no data"
              : `${showKPIModal?.name} performing KPIs`
          }
          showModal={showKPIModal}
          onClose={() => {
            setShowKPIModal(null);
          }}
          items={overviewKPIlist}
        />
        <InitiativeDrillDown
          title={
            showInitiatives?.name === "No Value"
              ? "Initiatives with no data"
              : `${showInitiatives?.name} performing Initiatives`
          }
          showModal={showInitiatives}
          onClose={() => {
            setShowInitiatives(null);
          }}
        />

        <SplitView partCnt={3} gap="30px">
          <OverallPerformanceCard
            element={el!}
            periodName={ctx.period || ""}
            key="PERF_W_YTD"
            titleKey="PERF_W_YTD_prettyvalue"
          />
          <ElementOverviewDonutCard
            title="KPI Overview"
            data={overviewKPIlist}
            typenames={["KPI"]}
            periodName={ctx.period || ""}
            onSelect={(event) => {
              console.log("setShowKPIModal", event);
              setShowKPIModal(event);
            }}
          />
          <ElementOverviewDonutCard
            title="Initiative Overview"
            data={overviewInitiativelist}
            typenames={["Initiative"]}
            periodName={ctx.period || ""}
            onSelect={(event) => {
              console.log("setShowInitiatives", event);
              setShowInitiatives(event);
            }}
          />
        </SplitView>

        <PerformanceSummaryBars
          elements={data}
          periodName={ctx.period || ""}
          typenames={["KPI", "Initiative"]}
          title="Perspective"
          onSelect={(event) => {
            if (event.category === "KPI") {
              setShowKPIModal(event);
            }
            if (event.category === "Initiative") {
              setShowInitiatives(event);
            }
          }}
        />
      </PageContainer>
    </Page>
  );
};
export default Overview;
